import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function Audience() {
  const isFor = ['Madres latinas en USA con niños de 2 a 7 años.', "Mujeres que se sienten agotadas y sienten que 'explotan' por cosas pequeñas.", 'Madres que quieren romper el ciclo de crianza con miedo que ellas mismas vivieron.', 'Quienes buscan una solución práctica, rápida y sin rodeos.'];
  const isNotFor = ['Personas que creen que el castigo físico es la única forma de educar.', "Quienes buscan una 'pastilla mágica' que solucione todo sin cambiar su propia conducta.", 'Padres que no están dispuestos a dedicar 10 minutos de conexión al día.'];
  return <section className="py-20 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-3">
          <FadeIn data-id="element-4">
            <div className="bg-sage-50 rounded-3xl p-8 md:p-10 border border-sage-200 h-full" data-id="element-5">
              <h3 className="text-3xl font-bold mb-8 text-sage-800 font-heading" data-id="element-6">
                Esto SÍ es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-7">
                {isFor.map((item, index) => <li key={index} className="flex gap-4 items-start" data-id="element-8">
                    <div className="bg-sage text-white rounded-full p-1 shrink-0 mt-1" data-id="element-9">
                      <Check className="w-5 h-5" data-id="element-10" />
                    </div>
                    <span className="text-lg text-sage-900 leading-relaxed" data-id="element-11">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-12">
            <div className="bg-coral-50 rounded-3xl p-8 md:p-10 border border-coral-200 h-full" data-id="element-13">
              <h3 className="text-3xl font-bold mb-8 text-coral-800 font-heading" data-id="element-14">
                Esto NO es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-15">
                {isNotFor.map((item, index) => <li key={index} className="flex gap-4 items-start" data-id="element-16">
                    <div className="bg-coral text-white rounded-full p-1 shrink-0 mt-1" data-id="element-17">
                      <X className="w-5 h-5" data-id="element-18" />
                    </div>
                    <span className="text-lg text-coral-900 leading-relaxed" data-id="element-19">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}